import { Provider as DirectionProvider } from "@radix-ui/react-direction";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const LanguageDirectionProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { i18n } = useTranslation();
  const [direction, setDirection] = useState(i18n.dir());

  useEffect(() => {
    const handleLanguageChange = (lang: string) => {
      const newDirection = i18n.dir(lang);
      setDirection(newDirection);
      document.documentElement.setAttribute("dir", newDirection);
      document.documentElement.setAttribute("lang", lang);
    };

    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", i18n.language);

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n, direction]);

  return <DirectionProvider dir={direction}>{children}</DirectionProvider>;
};
